import { http, HttpResponse } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import { chargePointData } from '../data/chargePointDataMock';
import type { GetChargingStationApiResponse } from '../../../src/store/facade/facadeApiV3';

const URL = `${BASE_URL_V3}${API.endpoints.chargingStations}/details/:id`;

export const chargingStationByIdResource = http.get(URL, () => {
    const response: GetChargingStationApiResponse = chargePointData;
    return HttpResponse.json(response, { status: 200 });
});

export default chargingStationByIdResource;
